import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { Email } from '../_classes/email';
import { Servidor } from '../_classes/servidor';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { EnvService } from '../_servicos/env.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  destinatario: string = 'Crisostomo Kolling';
  mensagem: string;

  carregando = false;

  modalRef: BsModalRef;

  servidor: Servidor;
  servidor$: Observable<Servidor>;

  mostrarAjuda = false;
  erros$ = new Subject<boolean>();

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private modalService: BsModalService,
    private service: RestService,
    private env: EnvService
  ) {}

  ngOnInit() {}

  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }

  handleError(e: any) {
    //console.log(e);
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro ao enviar mensagem, tente novamente',
      e
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  // base64toBlob(base64Data, contentType): Blob {
  //   contentType = contentType || '';
  //   let sliceSize = 1024;
  //   let byteCharacters = atob(base64Data);
  //   let bytesLength = byteCharacters.length;
  //   let slicesCount = Math.ceil(bytesLength / sliceSize);
  //   let byteArrays = new Array(slicesCount);

  //   for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
  //     let begin = sliceIndex * sliceSize;
  //     let end = Math.min(begin + sliceSize, bytesLength);

  //     let bytes = new Array(end - begin);
  //     for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
  //       bytes[i] = byteCharacters[offset].charCodeAt(0);
  //     }
  //     byteArrays[sliceIndex] = new Uint8Array(bytes);
  //   }
  //   return new Blob(byteArrays, { type: contentType });
  // }

  // convertDataURIToBinary(dataURI: string) {
  //   var raw = window.atob(dataURI);
  //   var rawLength = raw.length;
  //   var array = new Uint8Array(new ArrayBuffer(rawLength));

  //   for (var i = 0; i < rawLength; i++) {
  //     array[i] = raw.charCodeAt(i);
  //   }
  //   return array;
  // }

  enviarMensagem() {
    //console.log('vou enviar a seguinte mensagem');
    //console.log(this.mensagem);
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError('Excedido tempo de tentativa');
      }
    });
    this.servidor = this.env.servidor;
    //console.log('CKOLLING-feedback');
    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );

    if (this.servidor) {
      //console.log('servidor');
      //console.log(this.servidor);
      if (this.mensagem) {
        let msg: Email = new Email();
        msg.assunto = '[MEU PORTAL] Feedback online';
        msg.cco = this.servidor?.usuario?.dsNomeUsu + '@trt24.jus.br';
        msg.fkServidor = this.servidor.idServidor;
        msg.corpoStr = this.mensagem;
        //console.log('vou gravar feedback', msg);

        this.service.setFeedback(msg).subscribe(
          (x) => {
            //console.log('sucesso');
            //console.log(x);
            this.carregando = false;
            this.alertService.mostrarAlertaSucesso('Mensagem enviada', null);
            this.mensagem = '';
            this.modalRef.hide();
          },
          (e) => {
            //console.log('deu erro');
            //console.log(e);
            this.carregando = false;
            this.handleError(e);
            return EMPTY;
          }
        );
      } else {
        //console.log('nenhuma mensagem');
      }
    } else {
      //console.log('não consegui buscar servidor');
    }
  }
}
